import { NavLink } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";

// Main container for the Header section
const MainHeader = styled.header`
  width: 100%;
  height: 70px;
  background-color: #0d253f; /* Changed color */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
`;

const MainContainer = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  padding-top: 70px;
`;

const NavHeader = styled.h1`
  font-size: 30px;
  color: #ffffffff;
  text-align: center;
  background: linear-gradient(to right, #1f6feb, #0d253f); /* Changed gradient */
  padding: 20px;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(to right, #0056b3, #0d253f);
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    padding: 10px;
  }
`;

// Styled link that wraps the header text
const StyledLink = styled(NavLink)`
  text-decoration: none;
`;

const Header = () => {
  return (
    <>
      <MainContainer>
        <MainHeader>
          <StyledLink to="/">
            <NavHeader>AttractDeals</NavHeader>
          </StyledLink>
          <Navbar />
        </MainHeader>
      </MainContainer>
    </>
  );
};

export default Header;
